import { useAuth } from 'react-oidc-context';
import { useContext } from 'react';

import lsKey, { type LocalStorageKeyInput } from './base/localStorage.key';
import { AppContext } from '@/shared/context/context';

export const SHARED_TEAM_SEGMENT = 'all-teams';

export type ScopedKeyOptions = {
  shareAcrossTeams?: boolean;
};

const useScopedKeyInput = (keyInput: LocalStorageKeyInput, options?: ScopedKeyOptions) => {
  const { currentTeamId } = useContext(AppContext);

  const auth = useAuth();

  if (keyInput == null) return null;

  const userId = auth?.user?.profile.sub;

  if (!userId) return null;

  const teamSegment = options?.shareAcrossTeams ? SHARED_TEAM_SEGMENT : currentTeamId;

  if (!teamSegment) return null;

  return [userId, teamSegment, ...lsKey.parseInput(keyInput)];
};

export default useScopedKeyInput;
